import type { ExperienceItem as ExperienceItemData } from 'types/bio';
import styles from './experienceitem.module.scss';

interface ExperienceItemProps {
  item: ExperienceItemData;
}

const ExperienceItem: React.FC<ExperienceItemProps> = ({ item }) => {
  const dateRange = `${item.startDate} – ${item.endDate ?? 'present'}`;

  return (
    <section className={styles.experienceItemRoot}>
      <div className={`${styles.gridItem} ${styles.name}`}>{item.organization}</div>
      <div className={`${styles.gridItem} ${styles.title}`}>{item.title}</div>
      <div className={`${styles.gridItem} ${styles.date}`}>
        <p>{dateRange}</p>
        {item.location && <p>{item.location}</p>}
      </div>
      <div className={`${styles.gridItem} ${styles.description}`}>
        {item.description.map((para, i) => <p key={i}>{para}</p>)}
      </div>
    </section>
  );
};

export default ExperienceItem;
